import React from 'react'
import { TRouteBody } from 'common/hovercards/TRouteCard'
import { HoverCard } from 'common/hovercards/HoverCard'

export class RouteHoverCardLauncher extends React.PureComponent {
  render () {
    const {
      id,
      type,
      name,
      distance,
      elevationgain,
      elevationloss,
      movingTime,
      target
    } = this.props

    if (!id) return null

    return (
      <HoverCard
        target={target}
        theme='blueHeader'
        showOnMount
        tippyOptions={
          {
            duration: [200, 200],
            placement: 'right',
            sticky: false
          }
        }>
        <TRouteBody
          id={parseInt(id, 10)}
          name={name}
          type={type}
          distance={parseFloat(distance)}
          elevationGain={parseFloat(elevationgain)}
          elevationLoss={parseFloat(elevationloss)}
          movingTime={parseInt(movingTime)} />
      </HoverCard>
    )
  }
}
